export const hospitalInsuranceColumns = [
  'id',
  '_cdc_hash',
  '_cdc_seq',
  'r1_id',
  'revint_id',
  'account_number',
  'address',
  'balance',
  'contract_mapping_key',
  'contractual_adjustments',
  'expected_payments',
  'financial_class',
  'financial_class_description',
  'fk_hospital__encounter_master_id',
  'group_name',
  'group_number',
  'non_contractual_adjustments',
  'payer_code',
  'payer_name',
  'payer_position',
  'phone_number',
  'plan_code',
  'plan_name',
  'policy_number',
  'relationship',
  'snapshot_id',
  'subscriber_first_name',
  'subscriber_last_name',
  'total_adjustments',
];
